import { Box, Stack, TextField, Button, Tooltip, Typography, Autocomplete, FormControlLabel, Checkbox, Drawer, IconButton, FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { CurrencySymbol } from '../../../Utility/Constants'
import { ImagePaths } from '../../../Utility/ImagePaths'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useHistory, useLocation } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Loader from '../../../Components/Loader'
import { AmountFormat, CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'
import { localGetItem } from '../../../Utility/Services/CacheProviderService'

const fieldLimits = {
    CompanyName: 100,
    serviceSearch: 100,
    serviceSearchData: 100,
    serviceAmount: 10,
    customServiceHead: 50,
    customServiceName: 50,
};

export default function AddCorporateServiceConfig() {
    const location = useLocation();
    const PackId = location.state?.PackData[0]?.employer_id;
    const serviceConfig = JSON.parse(localGetItem("show_corporate_service_head"))
    const history = useHistory();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [formState, setFormState] = useState({
        searchList: [],
        serviceSearch: '',
        corpId: null,
        serviceSearchData: null,
        CompanyName: null,
        serviceName: '',
        serviceHead: '',
        serviceAmount: '',
        doctorShareRupee: '',
        hospitalShareRupee: '',
        doctorSharePercent: '',
        hospitalSharePercent: '',
        Sharable: false,
        customServiceHead: '',
        customServiceName: '',
    });
    const [CompanyList, setCompanyList] = useState([]);
    const [serviceList, setServiceList] = useState([]);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [isloader, setisloader] = useState(false);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [isDelete, setisDelete] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const [editMode, setEditMode] = useState(false);
    let commonDisable = CheckAccessFunc("front_office", "Settings", "Service Master Configuration", "Corporate Service Configuration", "SubTab")?.editAccess
    
    useEffect(() => {
        if (PackId) {
            getPackageIndividual();
        }
    }, [PackId]);

    useEffect(() => {
        if (formState?.serviceSearch?.length > 0) {
            getSearchData();
        }
    }, [formState?.serviceSearch])

    useEffect(() => {
        getCorporateList();
    }, [])

    const getSearchData = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.CONFIGURATION_SERVICE_SEARCH + `?search_key=${formState?.serviceSearch}&module_type=${'OP'}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setFormState((prevState) => ({ ...prevState, searchList: response.data.data || [], }));
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getPackageIndividual = (PackageId = null) => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.FO_NEW_CORPORATE_SERVICE_CONFIG + `?employer_id=${PackId || PackageId}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const serviceData = response.data.data || [];
                        setServiceList(serviceData);
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getCorporateList = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.FO_CONFIG_CORPORATE)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const CorporateData = response.data.data || [];
                        setCompanyList(CorporateData);
                        setisloader(false)
                        if (CorporateData?.length > 0 && location.state?.CompanyName) {
                            let CompanyName = CorporateData.filter((item) => item?.company_name === location.state?.CompanyName);
                            setFormState((prevState) => ({
                                ...prevState,
                                CompanyName: CompanyName[0]
                            }));
                        }
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }
    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const onChangeAuto = (e, val, name) => {
        switch (name) {
            case 'serviceSearchData':
                setFormState((prevState) => ({
                    ...prevState,
                    "serviceSearchData": val,
                    'Sharable': val?.is_sharable,
                }));
                break
            case 'CompanyName':
            case 'appliesTo':
                setFormState((prevState) => ({
                    ...prevState,
                    [name]: val
                }));
                break
        }
    }

    const [temp, setTemp] = useState({serviceAmount : '', doctorShareRupee : '', doctorSharePercent : '', hospitalShareRupee : '', hospitalSharePercent : ''  })

    const onChangeHandler = (e, name) => {
        let { value } = e.target;
    
        const isNumericField = [
            "serviceAmount",
            "doctorShareRupee",
            "doctorSharePercent",
            "hospitalShareRupee",
            "hospitalSharePercent"
        ].includes(name);

        const isTextField = ["customServiceHead", "customServiceName"].includes(name);
    
        if (isNumericField) {
            value = value.replace(/[^0-9 .]/g, "");  // Remove non-numeric characters execpt decimal point
            value = value.replace(/^0+/, "");        // Remove leading zeros
    
            // Prevent multiple decimals
            if ((value.match(/\./g) || []).length > 1) {
                return;
            }

            // Restrict decimal values to 2 digits
            if (value.includes(".")) {
                const [integer, decimal] = value.split(".");
                if (decimal.length > 2) {
                    return;  // Prevent typing more than 2 digits after decimal
                }
            }

            // Cap percentages at 100%
            if (name.includes("Percent")) {
                const numValue = parseFloat(value);
                if (!isNaN(numValue) && numValue > 100) {
                    value = "100";
                }
            }
        }

        if (isTextField) {
            if (value.length > 50) return;
        }
    
        // Update state with sanitized value
        let updatedState = { ...formState, [name]: value || "" };
        let updatedTemp = { ...temp, [name]: value || "" };

        const serviceAmount = parseFloat(updatedState.serviceAmount) || 0;

        updatedTemp.serviceAmount = serviceAmount // temp state for updating the accurate percentage values in temp
    
        if (name === "serviceAmount") {
            updatedState = {
                ...updatedState,
                doctorShareRupee: "",
                doctorSharePercent: "",
                hospitalShareRupee: "",
                hospitalSharePercent: ""
            };
    
            updatedTemp = {
                ...updatedTemp,
                doctorShareRupee: "",
                doctorSharePercent: "",
                hospitalShareRupee: "",
                hospitalSharePercent: ""
            };
        }

        if (serviceAmount > 0) {
            const doctorRupee = parseFloat(updatedState.doctorShareRupee) || 0;
            const hospitalRupee = parseFloat(updatedState.hospitalShareRupee) || 0;
            const doctorPercent = parseFloat(updatedState.doctorSharePercent) || 0;
            const hospitalPercent = parseFloat(updatedState.hospitalSharePercent) || 0;
    
            if (name === "doctorShareRupee") {
                const doctorShare = Math.min(doctorRupee, serviceAmount);
                const doctorPercent = (doctorShare / serviceAmount) * 100;
                
                const hospitalShare = serviceAmount - doctorShare;
                const hospitalPercent = (hospitalShare / serviceAmount) * 100;

                // Temp states update for doc share
                updatedTemp.doctorShareRupee = doctorShare;
                updatedTemp.doctorSharePercent = doctorPercent;
                updatedTemp.hospitalShareRupee = hospitalShare;
                updatedTemp.hospitalSharePercent = hospitalPercent;
                
                updatedState.doctorShareRupee = value > serviceAmount ? serviceAmount : value
                updatedState.doctorSharePercent = (doctorPercent).toFixed(2)
                updatedState.hospitalShareRupee = (hospitalShare).toFixed(2)
                updatedState.hospitalSharePercent = (hospitalPercent).toFixed(2)
    
            } else if (name === "hospitalShareRupee") {
                const hospitalShare = Math.min(hospitalRupee, serviceAmount);
                const hospitalPercent = (hospitalShare / serviceAmount) * 100;
    
                const doctorShare = serviceAmount - hospitalShare;
                const doctorPercent = (doctorShare / serviceAmount) * 100;

                  // Temp states update for hos share 
                updatedTemp.hospitalShareRupee = hospitalShare;
                updatedTemp.hospitalSharePercent = hospitalPercent;
                updatedTemp.doctorShareRupee = doctorShare;
                updatedTemp.doctorSharePercent = doctorPercent;
    
                updatedState.hospitalShareRupee = value > serviceAmount ? serviceAmount : value
                updatedState.hospitalSharePercent = (hospitalPercent).toFixed(2)
                updatedState.doctorShareRupee = (doctorShare).toFixed(2)
                updatedState.doctorSharePercent = (doctorPercent).toFixed(2)

            } else if (name === "doctorSharePercent") {
                const docPercent = Math.min(parseFloat(value) || 0, 100);
                const doctorShare = (serviceAmount * docPercent) / 100;
    
                const hospitalShare = serviceAmount - doctorShare;
                const hospitalPercent = (hospitalShare / serviceAmount) * 100;

                  // Temp states update for doc percent
                updatedTemp.doctorShareRupee = doctorShare;
                updatedTemp.doctorSharePercent = docPercent;
                updatedTemp.hospitalShareRupee = hospitalShare;
                updatedTemp.hospitalSharePercent = hospitalPercent;
    
                updatedState.doctorShareRupee = (doctorShare).toFixed(2);
                updatedState.doctorSharePercent = value; 
                updatedState.hospitalShareRupee = (hospitalShare).toFixed(2);
                updatedState.hospitalSharePercent = (hospitalPercent).toFixed(2);
    
            } else if (name === "hospitalSharePercent") {
                const hospPercent = Math.min(parseFloat(value) || 0, 100);
                const hospitalShare = (serviceAmount * hospPercent) / 100;
    
                const doctorShare = serviceAmount - hospitalShare;
                const doctorPercent = (doctorShare / serviceAmount) * 100;

                  // Temp states update for hos percent
                updatedTemp.hospitalShareRupee = hospitalShare;
                updatedTemp.hospitalSharePercent = hospPercent;
                updatedTemp.doctorShareRupee = doctorShare;
                updatedTemp.doctorSharePercent = doctorPercent;
    
                updatedState.hospitalShareRupee = (hospitalShare).toFixed(2);
                updatedState.hospitalSharePercent = value;  
                updatedState.doctorShareRupee = (doctorShare).toFixed(2);
                updatedState.doctorSharePercent = (doctorPercent).toFixed(2);
            }
        }

        // Update both states
        setTemp(updatedTemp);
        setFormState(updatedState);
    };


    const textBox = (label, name, val, width, disable = false, Symbol = null) => {
        let IntValue = ["doctorShareRupee", "hospitalShareRupee", 'doctorSharePercent', 'hospitalSharePercent'].includes(name)
        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    disabled={disable}
                    autoComplete='off'
                    value={val ? val : IntValue ? 0 : ""}
                    id="drug-master"
                    sx={{ width: width, marginRight: '0.3vw' }}
                    label={label}
                    inputProps={{
                        maxLength: fieldLimits[name] || 100,
                    }}
                    InputProps={Symbol ? {
                        style: { paddingRight: '0.5vw' },
                        endAdornment:
                            Symbol === 'rupee' ?
                                <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{CurrencySymbol}</Typography> :
                                <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>%</Typography>

                    } : null}
                    onChange={(e) => { onChangeHandler(e, name) }}
                    variant="outlined"
                />
            </Box>
        )
    }

    const autoComplete = (label, name, val, list, width) => {
        return (
            <Box>
                <Autocomplete
                    clearIcon
                    size={'small'}
                    options={list}
                    name={name}
                    disabled={name === 'CompanyName' && (location.state?.CompanyName || serviceList?.length > 0)}
                    getOptionLabel={(option) => name === 'CompanyName' ? option?.company_name : name === 'serviceSearchData' ? (`${option?.service_head_name || option?.service_head} ${option?.service_head_code ? `(${option?.service_head_code})` : ''} - ${option?.service_name} ${option?.service_code ? `(${option?.service_code})` : ''}`) : option}
                    value={val}
                    onInputChange={(e, newInputValue) => {
                        if (name === 'serviceSearchData') {
                            newInputValue && setFormState((prevState) => ({ ...prevState, serviceSearch: newInputValue }));
                        } 
                    }}
                    onChange={(event, newValue) => { onChangeAuto(event, newValue, name) }}
                    renderInput={(params) => <TextField {...params} label={label} sx={{ width: width, marginRight: '0.3vw' }} />}
                />
            </Box>
        )
    }


    const tableView = () => {
        const grpDelete = () => {
            setisDelete(true)
        }
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} />
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = serviceList.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item?.id)
            })
            setdelIDs(FinalData)
        }

        serviceList?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'service_head', headerName: 'Service Head Details', flex: 0.30,
                renderCell: (params) => {
                    const serviceHeadName = params.row.service_head_name || params.row.service_head;
                    return (serviceHeadName ? serviceHeadName?.length > 35 || params.row.service_head_code?.length > 35 ?
                        <Tooltip placement="top" title={`${params.row.service_head_code ? params.row.service_head_code + ' - ' : ''}${serviceHeadName}`}><Typography fontSize={'0.9vw'}>{params.row.service_head_code ? params.row.service_head_code + ' - ' : ''}{serviceHeadName.slice(0, 33) + '...'}</Typography></Tooltip> :
                        <Typography fontSize={'0.9vw'}>{params.row.service_head_code ? params.row.service_head_code + ' - ' : ''}{serviceHeadName}</Typography> : '-')
                }
            },
            {
                field: 'service_name', headerName: 'Service Name Details', flex: 0.30,
                renderCell: (params) => (params.row.service_name ? params.row.service_name?.length > 35 || params.row.service_code?.length > 35 ?
                    <Tooltip placement="top" title={`${params.row.service_code ? params.row.service_code + ' - ' : ''}${params.row.service_name}`}><Typography fontSize={'0.9vw'}>{params.row.service_code ? params.row.service_code + ' - ' : ''}{params.row.service_name.slice(0, 33) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.service_code ? params.row.service_code + ' - ' : ''}{params.row.service_name}</Typography> : '-')
            },
            {
                field: 'service_amount', headerName: 'Service Amount', flex: 0.25,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.total_amount ?  AmountFormat(params?.row?.total_amount)?.replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
            },
            // {
            //     field: 'action', headerName: 'Action', flex: 0.15,
            //     renderCell: (params) => (
            //         <Stack direction="row" alignItems="center" spacing={4}>
            //             <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
            //                 <CommonEditButton size="1.5vw" onClick={() => { handleEdit(params.row) }} />
            //             </Stack>
            //         </Stack>)
            // },
        ]

        const handleEdit = (row) => {            
            setFormState((prevState) => ({
                ...prevState,
                // searchList: [],
                // serviceSearch: '',
                corpId: row?.id,
                serviceSearchData: row,
                CompanyName: row?.company_name,
                serviceHead: row?.service_head,
                serviceName: row?.service_name,
                serviceAmount: row?.total_amount,
                doctorShareRupee: row?.doctor_share_amount,
                hospitalShareRupee: row?.hospital_share_amount,
                doctorSharePercent: row?.doctor_share_percent,
                hospitalSharePercent: row?.hospital_share_percent,
                Sharable: row?.is_sharable == true || row?.doctor_share_amount || row?.hospital_share_amount ? true : false,
                customServiceHead: row?.custom_service_head || '',
                customServiceName: row?.custom_service_name || '',
            }));
            setEditMode(true);
        };

        return (
            <Box sx={{ flex: 1, height: '100%', marginTop: '.5vw' }}>
                <DataGrid
                    checkboxSelection={commonDisable ? true : false}
                    selectionModel={CheckBoxList}
                    onSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={serviceList}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={page}
                    pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    // hideFooter
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setpage(newPage) }}
                    onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const closeFilter = () => {
        setFilterOpen(false);
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
    }

    const AddPackageData = (formSave) => {        
        try {
            if (!formState?.CompanyName || (!formSave && !formState?.serviceSearchData) || !formState?.serviceAmount) {
                return errorMessage('Please Enter All mandatory fields');
            }

            if (formState?.Sharable === true ? !formState.doctorShareRupee && !formState.doctorSharePercent && !formState.hospitalShareRupee && !formState.hospitalSharePercent : '') {
                return errorMessage('Please Enter All mandatory fields')
            }

            if (formState?.customServiceHead && !formState?.customServiceName) {
                return errorMessage('Please Enter Custom Service Name');
            }

            if (formState?.Sharable) {
                const serviceAmount = parseFloat(formState?.serviceAmount || 0);
                const doctorShare = parseFloat(formState?.doctorShareRupee || 0);
                const hospitalShare = parseFloat(formState?.hospitalShareRupee || 0);
            
                if (serviceAmount !== (doctorShare + hospitalShare)) {
                    return errorMessage('Service charge is not equal to the sum of doctor and hospital shares');
                }
            }

            const duplicateItem = serviceList?.find(item => {
                const head = (item?.display_service_head || item?.service_head || item?.service_head_name || '').trim().toLowerCase();
                const name = (item?.display_service_name || item?.service_name || '').trim().toLowerCase();

                const customHead = (formState?.customServiceHead || '').trim().toLowerCase();
                const customName = (formState?.customServiceName || '').trim().toLowerCase();

                return head === customHead || name === customName;
            });

            if (duplicateItem) {
                const head = (duplicateItem?.display_service_head || duplicateItem?.service_head || duplicateItem?.service_head_name || '').trim().toLowerCase();
                const name = (duplicateItem?.display_service_name || duplicateItem?.service_name || '').trim().toLowerCase();

                const customHead = (formState?.customServiceHead || '').trim().toLowerCase();
                const customName = (formState?.customServiceName || '').trim().toLowerCase();

                if (head === customHead && name === customName) {
                    return errorMessage("Same custom service head and custom service name already added");
                }

                if (name === customName) {
                    return errorMessage("Same custom service name already added");
                }

                if (head === customHead) {
                    return errorMessage("Same custom service head already added");
                }
            } 


            // as of now due to the  backend save structure is not in formSave
            if (formSave) {
                setisloader(true);
                history.push("/Settings/NewService/CorpPackageConfig");
                setisloader(false);
                return
            }   

            let data = {
                "id": formState?.corpId,
                "service_details_id": formState?.serviceSearchData?.service_details_id,
                "employer_id": formState?.CompanyName?.id,
                "doctor_share_percent": formState?.Sharable ? formState?.doctorSharePercent ? Number(temp?.doctorSharePercent) : 0 : 0,
                "hospital_share_percent": formState?.Sharable ? formState?.hospitalSharePercent ? Number(temp?.hospitalSharePercent) : 0 : 0,
                "doctor_share_amount": formState?.Sharable ? formState?.doctorShareRupee ? Number(temp?.doctorShareRupee) : 0 : 0,
                "hospital_share_amount": formState?.Sharable ? formState?.hospitalShareRupee ? Number(temp?.hospitalShareRupee) : 0 : 0,
                "total_amount": formState?.serviceAmount ? Number(temp?.serviceAmount) : 0,
                "service_code": formState?.serviceSearchData?.service_code,
                "display_service_head": formState?.customServiceHead ? formState?.customServiceHead : formState?.customServiceHead === '' ? formState?.serviceSearchData?.service_head_name : formState?.serviceSearchData?.service_head,
                "display_service_name": formState?.customServiceName ? formState?.customServiceName : formState?.customServiceName === '' ? formState?.serviceSearchData?.service_name : '',
            };
            setisloader(true)
            RestAPIService.create(data, Serviceurls.FO_NEW_CORPORATE_SERVICE_CONFIG)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        successMessage(response.data.message)
                        getPackageIndividual(formState?.CompanyName?.id);
                        setServiceList((prevList) => [...prevList, formState?.serviceSearchData]);
                        setFormState((prevState) => ({
                            ...prevState,
                            searchList: [],
                            serviceSearch: '',
                            serviceSearchData: null,
                            serviceName: '',
                            serviceAmount: '',
                            doctorShareRupee: '',
                            hospitalShareRupee: '',
                            doctorSharePercent: '',
                            hospitalSharePercent: '',
                            Sharable: false,
                            customServiceHead: '',
                            customServiceName: '',
                        }));
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const deleteIndivudualData = () => {
        try {
            setisloader(true)
            RestAPIService.delete(`${Serviceurls.FO_NEW_CORPORATE_SERVICE_CONFIG}?id=${delIDs || []}`, {})
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        closeFilter();
                        setisloader(false)
                        if (formState?.CompanyName?.id) {
                            getPackageIndividual(formState?.CompanyName?.id);
                        }
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const renderFilterScreen = () => {
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{"Filter"}</Typography>
                    <Button onClick={() => { setFilterOpen(false) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_rts_dropdown'>
                        {/* <Autocomplete
                            size='small'
                            options={department_category}
                            value={filterdepartment}
                            onChange={(event, newValue) => {
                                setFilterDepartment(newValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Vendor Catogory'}
                                />
                            )}
                        /> */}
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => { }}
                        id="eMed_Config_btn">{"Clear"}</Button>
                    <Button variant='contained' size="small"
                        onClick={() => {
                            setFilterOpen(false);
                        }}
                        id="eMed_Config_btn">{"Search"}</Button>
                </Stack>
            </Box>
        )
    }

    const prevent = () => {
        history.push("/Settings/NewService/CorpPackageConfig");
    };    

    return (
        <Box component={'div'} sx={{ height: '87vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray' }}>
                <IconButton onClick={() => prevent()}>
                    <ChevronLeftIcon color='primary' />
                </IconButton>
                <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Back To Corporate Service Configuration'}</Typography>
            </Box>

            <Box component={'div'} sx={{ minHeight: '14vh', height: 'auto', width: '93vw', backgroundColor: 'white', marginTop: "1vw" }}>
                <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} justifyContent={'space-between'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray', paddingLeft: "0.5vw" }}>
                    <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Corporate Service Configuration'}</Typography>
                </Box>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', alignItems: "center", height: "9vh", paddingLeft: "0.5vw" }}>
                    {autoComplete("Select Company Name*", 'CompanyName', formState?.CompanyName, CompanyList, '30.3vw', PackId)}
                </Box>
            </Box>
            
            <Box component={'div'} sx={{ width: '93vw', backgroundColor: 'white', mt: '0.5vw', overflow: 'hidden', minHeight: '14vh', }}>
                <Box component={'div'} sx={{ minHeight: '5vh', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid lightgray', pl: '0.5vw', pr: '0.5vw', py: '0.4vw', }}>
                    <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Service Configuration'}</Typography>
                    <Box sx={{ mr: "0.95vw" }}>
                        <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw' }} disabled={!commonDisable} onClick={() => {
                            setFormState((prevState) => ({
                                ...prevState,
                        searchList: [],
                        serviceSearch: '',
                        serviceSearchData: null,
                        serviceName: '',
                        serviceAmount: '',
                        doctorShareRupee: '',
                        hospitalShareRupee: '',
                        doctorSharePercent: '',
                        hospitalSharePercent: '',
                        Sharable: false,
                        customServiceHead: '',
                        customServiceName: '',
                            }));
                        }}>Clear</Button>
                        <Button size='small' variant='contained' sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: '0.5vw' }} disabled={!formState?.serviceSearchData && !commonDisable} onClick={() => { AddPackageData() }}>Add</Button>
                    </Box>
                </Box>
                <Box component={'div'} sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', py: '0.7vw', minHeight: '9vh', gap: '0.5vw', }}>
                    {autoComplete("Search Service Code/Head/Name*", 'serviceSearchData', formState?.serviceSearchData, formState?.searchList, '30.3vw')}
                    {textBox("Service Amount*", 'serviceAmount', formState?.serviceAmount, '12vw', !formState?.serviceSearchData)}
                    {formState?.Sharable ? textBox("Doctor Share*", 'doctorShareRupee', formState?.doctorShareRupee, '12vw', !formState?.serviceAmount, 'rupee') : null}
                    {formState?.Sharable ? textBox("Doctor Percent*", 'doctorSharePercent', formState?.doctorSharePercent, '12vw', !formState?.serviceAmount, 'percent') : null}
                    {formState?.Sharable ? textBox("Hospital Share*", 'hospitalShareRupee', formState?.hospitalShareRupee, '12vw', !formState?.serviceAmount, 'rupee') : null}
                    {formState?.Sharable ? textBox("Hospital Percent*", 'hospitalSharePercent', formState?.hospitalSharePercent, '12vw', !formState?.serviceAmount, 'percent') : null}
                    {serviceConfig && (
                        <>
                            {textBox("Custom Service Head", 'customServiceHead', formState?.customServiceHead, '12vw', !formState?.serviceSearchData)}
                            {textBox("Custom Service Name", 'customServiceName', formState?.customServiceName, '12vw', !formState?.serviceSearchData)}
                        </>
                    )}
                </Box>
            </Box>

            <Box component={'div'} sx={{ flex: 1, width: '93vw', marginTop: '.5vw', backgroundColor: 'white', overflow: 'hidden', minHeight: 0 }}>
                {tableView()}
            </Box>
            <Drawer
                anchor={'right'}
                open={filterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={`Are you sure, Do you want to delete this item ?`}
                    DeleteNotify={"If you remove this, this could be effect in entire Configuration"}
                    deleteAlertPopupClose={closeFilter}
                    removeData={deleteIndivudualData}
                />
                : null}
            <Loader loaderOpen={isloader} />
        </Box>
    )
}